import qs from'qs';export var getParams=function getParams(){return qs.parse(window.location.search.replace('?',''));};